<template>
    <div class="form-subscription-method-add">
        <div class="mb-4">
            <form-stripe-payment-method
                :payment-amount="null"
                :payment-error="paymentError"
                :on-create-payment-method="handleCreatePaymentMethod"
            ></form-stripe-payment-method>
        </div>
        <div class="flex gap-2">
            <img src="/images/card-visa.png" alt="Visa" class="h-10 rounded-sm border border-zinc-300" />
            <img src="/images/card-mastercard.png" alt="Mastercard" class="h-10 rounded-sm border border-zinc-300" />
            <img src="/images/card-amex.png" alt="American Express" class="h-10 rounded-sm border border-zinc-300" />
            <div class="grow"></div>
            <img src="/images/powered-by-stripe.png" alt="Powered by Stripe" class="h-10" />
        </div>
        <div class="mt-6">
            <div class="flex flex-row">
                <button-regular
                    buttonColor="bg-white text-black border border-zinc-200 hover:border-zinc-300 focus-visible:outline-zinc-600"
                    buttonText="Cancel"
                    :buttonClick="cancel"
                ></button-regular>
                <div class="grow"></div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions} from 'pinia';

export default {
    name: 'FormSubscriptionMethodAdd',
    emits: ['closed'],
    computed: {
        ...mapState(useStoreSubscription, {
            paymentError: 'paymentError',
        }),
    },
    methods: {
        ...mapActions(useStoreSubscription, {
            postPaymentMethod: 'postPaymentMethod',
        }),
        async handleCreatePaymentMethod(paymentMethod) {
            try {
                await this.postPaymentMethod(paymentMethod);
                this.$emit('closed');
            } catch (error) {
                // Error is handled in the store
            }
        },
        cancel() {
            this.$emit('closed');
        },
    },
};
</script>
